import siteData from "./data/jigpaws_pages.json";
import {Helmet} from "react-helmet";
import {DebugWarnings, DebugOutput} from "../Debug/Debug";
import { productRegistry } from "../models";

// export function getPageData({ pageType, category, product }) {
//   // Find the page type first
//   const pageTypeObj = siteData.find(item => item["Page Type"] === pageType);
//   const page = pageTypeObj.Pages.find(page => {
//   const categoryMatches = category
//     ? page.Category.toLowerCase() === category.toLowerCase()
//     : true; // ignore if no category passed
//
//   const productMatches = product
//     ? (page.Product || "").toLowerCase() === product.toLowerCase()
//     : true; // ignore if no product passed
//
//   return categoryMatches && productMatches;
// });
//
//   // Transform to a "clean object"
//   return {
//     parent: pageTypeObj["Page Type"],
//     meta: {
//       title: page["Optimised Title"] || "",
//       description: page["Meta Description"] || "",
//       image:  page["Image"] ||""
//     },
//     content: {
//       h1: page["H1"] || ""
//     },
//     oldUrl: page["Current URL"] || "",
//     indexable: page["Is indexable page"] || false,
//     category: page.Category || "",
//     product: page.Product || "",
//   };
// }
function deriveProductUrl(category, product) {
    const categorySlug = category.toLowerCase();
    const registryEntry = Object.values(productRegistry).find(
        entry => entry.display.toLowerCase() === product.toLowerCase()
    );
    const productSlug = registryEntry ? registryEntry.slug : product.toLowerCase();
    return categorySlug === 'personalised'
        ? `/product/personalised-${productSlug}`
        : `/product/personalised-${categorySlug}-${productSlug}`;
}

export function getPageData({ pageType, category, product, url }) {
  const pageTypeObj = siteData.find(item => item["Page Type"] === pageType);

  // const page = pageTypeObj.Pages.find(page => {
  //   if (url !== undefined) {
  //     return page["URL"] === url;
  //   }
    const page = pageTypeObj.Pages.find(page => {
    if (pageType === "Product" && url !== undefined) {
      const derived = deriveProductUrl(page.Category, page.Product);
      return derived === url;
    }

    if (url !== undefined) {
      return page["URL"] === url;
    }
    const categoryMatches = category
      ? page.Category.toLowerCase() === category.toLowerCase()
      : true;

    const productMatches = product
      ? (page.Product || "").toLowerCase() === product.toLowerCase()
      : true;

    return categoryMatches && productMatches;
  });
const domain = "https://www.jigpaws.com";

  return {
    parent: pageTypeObj["Page Type"],
    category: page.Category || null,
    product: page.Product || null,
    id: page.ID || null,
    meta: {
      title: page["Optimised Title"] || null,
      description: page["Meta Description"] || null,
      image: page["Image-src"] ? `${domain}${page["Image-src"]}` : null,
      canonical: page["URL"]
    },
    relLink: page["URL"] ? new URL(page["URL"]).pathname : null,
    image: {
        src: page["Image-src"] || null,
        alt: page["Image-description"] || page["Meta Description"] || null
    },
    content: {
      h1: page["H1"] || null
    },
    indexable: page["Is indexable page"] || false,
  };
}

// GET PAGES BY TYPE
export function getPagesByType(pageType) {
  const pageTypeObj = siteData.find(item => item["Page Type"] === pageType);
  return (pageTypeObj?.Pages || []).map(page =>
    getPageData({ pageType, url: page["URL"] })
  );
}

export function StructureDebug({ pageData }) {
  if (!pageData) return <p>No page data available</p>;

  const renderObject = (obj, parentKey = "") =>
    Object.entries(obj).map(([key, value]) => {
      const label = parentKey ? `${parentKey} → ${key}` : key;

      if (value && typeof value === "object" && !Array.isArray(value)) {
        return (
          <div key={label} style={{ marginLeft: "10px" }}>
            {renderObject(value, label)}
          </div>
        );
      }

      return (
        <p key={label}>
          <strong>{label}:</strong> {String(value)}
        </p>
      );
    });

  // Actual URL
  const actualUrl = typeof window !== "undefined" ? window.location.href : "";
  const jsonUrl = pageData.meta.canonical || "";

  // Compare **paths only**, ignoring hostname
  const actualPath = actualUrl ? new URL(actualUrl).pathname : "";
  const jsonPath = jsonUrl ? new URL(jsonUrl).pathname : "";
  const urlMismatch = actualPath !== jsonPath;

  return (
      <div>
          {/*          <DebugOutput>*/}
          {/*              {pageData.image?.src && (*/}
          {/*    <img*/}
          {/*      src={pageData.image.src}*/}
          {/*      alt={pageData.image.alt}*/}
          {/*      style={{ maxWidth: "200px", marginTop: "10px" }}*/}
          {/*    />*/}
          {/*  )}*/}
          {/*{renderObject(pageData)}*/}
          {/*          </DebugOutput>*/}
          <DebugOutput>
          </DebugOutput>
          <div className="spacerMed"/>
          <p><strong>Title:</strong> {pageData.meta.title}</p>
          <p><strong>Description:</strong> {pageData.meta.description}</p>
          <div className="spacerSmall"/>
          {pageData.image?.src && (
              <img
                  src={pageData.image.src}
                  alt={pageData.image.alt}
                  style={{maxWidth: "200px", display: "block", marginBottom: "8px", margin: "0 auto"}}
              />
          )}
          <div className="spacerSmall"/>
          <p><strong>Image description:</strong> {pageData.image?.alt}</p>
          <div className="spacerMed"/>
          {urlMismatch && (
              <DebugWarnings>

                  {/*<div style={{ marginTop: "1em", padding: "10px", borderTop: "1px solid red", color: "red" }}>*/}
                  <h4>URL Mismatch!</h4>
                  <p>
                      <strong>JSON URL:</strong> {jsonUrl || "(none)"}
                  </p>
                  <p>
                      <strong>Actual URL:</strong> {actualUrl || "(unknown)"}
                  </p>
                  {/*</div>*/}
              </DebugWarnings>
          )}
          {!pageData.indexable && (
    <DebugWarnings>
        <h4>Non-indexable page!</h4>
        <p>This page has <strong>noindex, nofollow</strong> set.</p>
    </DebugWarnings>
)}
      </div>
  );
}

export function SeoComponent({page }) {
  const { meta, indexable, URL } = page;
  const title = meta.title;
  const description = meta.description;
  const ogTitle = meta.title;
  const link = meta.canonical;
  const ogImage = meta.image;
  return (
      <Helmet>
          <title>{title}</title>
          <meta name="description" content={description}/>
          <link rel="canonical" href={link}/>
          <meta property="og:title" content={ogTitle}/>
          <meta property="og:url" content={link}/>
          <meta property="og:type" content="article"/>
          <meta property="og:description" content={description}/>
          {ogImage && <meta property="og:image" content={ogImage}/>}
          {!indexable && <meta name="robots" content="noindex, nofollow"/>}
      </Helmet>
  );
}